import Vue from 'vue'
import Router from 'vue-router'
import SelectVehicle from '@/components/steps/SelectVehicle'
import SelectSystem from '@/components/steps/SelectSystem'
import SelectCommunicationType from '@/components/steps/SelectCommunicationType'
import SelectUpgrades from '@/components/steps/SelectUpgrades'
import SelectRemote from '@/components/steps/SelectRemote'
import ViewSystem from '@/components/steps/ViewSystem'
import ContactDealer from '@/components/steps/ContactDealer'
import ThankYou from '@/components/steps/ThankYou'
import DealerFollowup from '@/components/steps/DealerFollowup'
import DealerFollowupComplete from '@/components/steps/DealerFollowupComplete'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'selectVehicle',
      component: SelectVehicle
    },
    {
      path: '/select-system',
      name: 'selectSystem',
      component: SelectSystem
    },
    {
      path: '/select-communication',
      name: 'selectCommunicationType',
      component: SelectCommunicationType
    },
    {
      path: '/select-remote',
      name: 'selectRemote',
      component: SelectRemote
    },
    {
      path: '/select-upgrades',
      name: 'selectUpgrades',
      component: SelectUpgrades
    },
    {
      path: '/view-system/',
      name: 'viewSystem',
      component: ViewSystem
    },
    {
      path: '/view-system/:inquiryId/:quoteId',
      name: 'viewSystem',
      component: ViewSystem,
      props: true
    },
    {
      path: '/contact-dealer',
      name: 'contactDealer',
      component: ContactDealer
    },
    {
      path: '/thank-you/:inquiryId/:quoteId',
      name: 'thankYou',
      component: ThankYou,
      props: true
    },
    {
      path: '/dealer-followup/:inquiryId/:quoteId',
      name: 'dealerFollowup',
      component: DealerFollowup,
      props: true
    },
    {
      path: '/dealer-followup-complete/:inquiryId/:quoteId',
      name: 'dealerFollowup',
      component: DealerFollowupComplete,
      props: true
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 120 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js